Ext.define('SA.view.mapexport.overlay.OverlayEditWindow', {
    alias: 'widget.export-overlay-edit-window',
    extend: 'SA.view.mapexport.overlay.AbstractEditWindow',

    cls: 'sa-overlay-edit-window',

    initComponent() {
        this.items = [
            {
                xtype: 'export-units-field',
                allowDecimals: false,
                cls: 'sa-overlay-edit-window-units-field',
                fieldLabel: 'Width',
                itemId: 'width',
                labelWidth: 47,
                readOnly: !this.overlayResizable,
                width: 165
            }, {
                xtype: 'export-units-field',
                allowDecimals: false,
                cls: 'sa-overlay-edit-window-units-field',
                fieldLabel: 'Height',
                itemId: 'height',
                labelWidth: 47,
                readOnly: !this.overlayResizable,
                width: 165
            }, {
                xtype: 'export-units-field',
                allowDecimals: false,
                cls: 'sa-overlay-edit-window-units-field',
                fieldLabel: 'Left',
                itemId: 'left',
                labelWidth: 47,
                width: 165
            }, {
                xtype: 'export-units-field',
                allowDecimals: false,
                cls: 'sa-overlay-edit-window-units-field',
                fieldLabel: 'Top',
                itemId: 'top',
                labelWidth: 47,
                width: 165
            }
        ];

        this.callParent();

        this.widthField = this.down('#width');
        this.heightField = this.down('#height');
        this.leftField = this.down('#left');
        this.topField = this.down('#top');
    },

    refresh() {
        var dimensions = this.dimensions;

        this.widthField.setValue(dimensions.width);
        this.heightField.setValue(dimensions.height);

        this.leftField.setValue(dimensions.left);
        this.topField.setValue(dimensions.top);
    }
});